﻿import {
	PermitFullEntityResult,
	RequiredVehicleProperties,
	VehicleId,
	VehicleResult
} from "@2d-front-monorepo/permits-business";
import {JSX} from "react";
import {VehicleComponent} from "./VehicleComponent";

export function VehicleWithChangeComponent({vehicle, hiddenEntityProperties, changedVehicle}: {
	vehicle: PermitFullEntityResult<VehicleId, VehicleResult>,
	hiddenEntityProperties: RequiredVehicleProperties,
	changedVehicle: PermitFullEntityResult<VehicleId, VehicleResult> | undefined,
}): JSX.Element | undefined {
	if (changedVehicle == null) {
		return <VehicleComponent vehicle={vehicle} hiddenEntityProperties={hiddenEntityProperties} showStatus={false} />;
	}

	return <div className="columns gap">
		<div className="col50"><VehicleComponent vehicle={vehicle} hiddenEntityProperties={hiddenEntityProperties} showStatus={true} /></div>
		<div className="col50"><VehicleComponent vehicle={changedVehicle} hiddenEntityProperties={hiddenEntityProperties} showStatus={true} /></div>
	</div>;
}
